"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOneGraphUrl = exports.getEnv = exports.Env = void 0;
var Env;
(function (Env) {
    Env[Env["Prod"] = 0] = "Prod";
    Env[Env["QA"] = 1] = "QA";
    Env[Env["LocalHost"] = 2] = "LocalHost";
})(Env = exports.Env || (exports.Env = {}));
const getEnv = () => {
    const hostname = window.location.hostname;
    if (hostname.indexOf('indeed.com') !== -1) {
        return Env.Prod;
    }
    else if (hostname.indexOf('localhost') !== -1) {
        return Env.LocalHost;
    }
    else {
        return Env.QA;
    }
};
exports.getEnv = getEnv;
const getOneGraphUrl = (env) => {
    switch (env) {
        case Env.Prod:
            return 'https://apis.indeed.com/graphql';
        case Env.QA:
        case Env.LocalHost:
        default:
            return 'https://apis.qa.indeed.net/graphql';
    }
};
exports.getOneGraphUrl = getOneGraphUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJpSGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy91cmlIZWxwZXJzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLEdBSVg7QUFKRCxXQUFZLEdBQUc7SUFDWCw2QkFBSSxDQUFBO0lBQ0oseUJBQUUsQ0FBQTtJQUNGLHVDQUFTLENBQUE7QUFDYixDQUFDLEVBSlcsR0FBRyxHQUFILFdBQUcsS0FBSCxXQUFHLFFBSWQ7QUFFTSxNQUFNLE1BQU0sR0FBRyxHQUFRLEVBQUU7SUFDNUIsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUM7SUFDMUMsSUFBSSxRQUFRLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFO1FBQ3ZDLE9BQU8sR0FBRyxDQUFDLElBQUksQ0FBQztLQUNuQjtTQUFNLElBQUksUUFBUSxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRTtRQUM3QyxPQUFPLEdBQUcsQ0FBQyxTQUFTLENBQUM7S0FDeEI7U0FBTTtRQUNILE9BQU8sR0FBRyxDQUFDLEVBQUUsQ0FBQztLQUNqQjtBQUNMLENBQUMsQ0FBQztBQVRXLFFBQUEsTUFBTSxVQVNqQjtBQUVLLE1BQU0sY0FBYyxHQUFHLENBQUMsR0FBUSxFQUFVLEVBQUU7SUFDL0MsUUFBUSxHQUFHLEVBQUU7UUFDVCxLQUFLLEdBQUcsQ0FBQyxJQUFJO1lBQ1QsT0FBTyxpQ0FBaUMsQ0FBQztRQUM3QyxLQUFLLEdBQUcsQ0FBQyxFQUFFLENBQUM7UUFDWixLQUFLLEdBQUcsQ0FBQyxTQUFTLENBQUM7UUFDbkI7WUFDSSxPQUFPLG9DQUFvQyxDQUFDO0tBQ25EO0FBQ0wsQ0FBQyxDQUFDO0FBVFcsUUFBQSxjQUFjLGtCQVN6QiJ9